/* ============================================================================
   goody-splash-i18n.js  (ASSET SHOPIFY)
   - Fournit window.GOODY_SPLASH_I18N.I18N (FR/EN/ES)
   - Fournit window.GOODY_SPLASH_I18N.LEXICON (verrou corpus)
   - ✅ Fix critique : FR présent => la page ne “bascule” plus en EN par défaut
   - ✅ Fix : textes des 2 popups (who/approach) rétablis en FR/EN/ES
   - ✅ Posœnnoïsme : traduction EN/ES, en conservant “œ”
   - ✅ Version 2 (élégante) : UI = langue utilisateur ; Lexique opératif = “famille”
       * es-*  => lexique "es"
       * pt-*  => lexique "es" (règle ibéro/Amérique latine)
       * en-*  => lexique "en" (toutes variantes anglophones)
       * sinon => lexique = base si dispo, sinon "fr"
   - ✅ Verrou lexique : on protège les graphies “corpus” (dont variantes traduites)
   ============================================================================ */

(function(){
  "use strict";

  // --- Namespace ---
  window.GOODY_SPLASH_I18N = window.GOODY_SPLASH_I18N || {};
  const NS = window.GOODY_SPLASH_I18N;

  // --- Helpers ---
  // Optimisation: freezeDeep itératif (évite récursion profonde, réduit risques + overhead)
  function freezeDeep(root){
    try{
      if(!root || (typeof root !== "object" && typeof root !== "function")) return root;
      const stack = [root];

      while(stack.length){
        const o = stack.pop();
        if(!o || (typeof o !== "object" && typeof o !== "function")) continue;
        if(Object.isFrozen(o)) continue;

        Object.freeze(o);

        // for..in + hasOwnProperty : stable et rapide ici
        for(const k in o){
          if(!Object.prototype.hasOwnProperty.call(o, k)) continue;
          const v = o[k];
          if(v && (typeof v === "object" || typeof v === "function") && !Object.isFrozen(v)){
            stack.push(v);
          }
        }
      }
    }catch(e){}
    return root;
  }

  function normalizeLangTag(tag){
    // Optimisation: replace global '_' => '-' (au lieu d’un seul)
    const t = (tag || "").toLowerCase().trim().replace(/_/g, "-");
    if(!t) return { full:"", base:"" };
    const i = t.indexOf("-");
    const base = (i === -1) ? t : t.slice(0, i);
    return { full:t, base };
  }

  // --- Politique de langues (Version 2) ---
  // UI: pack = base si dispo, sinon "fr"
  // Lexique opératif: es-* => "es", pt-* => "es", en-* => "en", sinon base si dispo, sinon "fr"
  function resolveUiKey(tag, I18N){
    const keys = Object.keys(I18N || {});
    const base = normalizeLangTag(tag).base;
    if(base && I18N && I18N[base]) return base;
    if(I18N && I18N.fr) return "fr";
    return keys[0] || "fr";
  }

  function resolveLexiconKey(tag, I18N){
    const keys = Object.keys(I18N || {});
    const base = normalizeLangTag(tag).base;

    // Famille ibéro-américaine => lexique "es"
    if(base === "es" || base === "pt"){
      return (I18N && I18N.es) ? "es" : (I18N && I18N.fr ? "fr" : (keys[0] || "fr"));
    }

    // Toutes variantes anglophones => lexique "en"
    if(base === "en"){
      return (I18N && I18N.en) ? "en" : (I18N && I18N.fr ? "fr" : (keys[0] || "fr"));
    }

    // Sinon: base si dispo
    if(base && I18N && I18N[base]) return base;

    // Fallback
    if(I18N && I18N.fr) return "fr";
    return keys[0] || "fr";
  }

  // --- LEXICON : termes à ne jamais “traduire” / à préserver tels quels ---
  // Note : Posœnnoïsme est TRADUIT en EN/ES chez toi, donc on protège aussi ces variantes.
  // Le verrou est “graphique” : il garantit que ces formes ne seront jamais déformées.
  const LEXICON = [
    "Goodÿ",
    "Posœnnoïsme",
    "Posœnnoïste",
    "Posœnnoism",
    "Posœnnoísmo",
    "Katûvýs",
    "Katûpirsia",
    "Kiyegudi",
    "Anaxagore",
    "ADAGP",
    "Guadeloupe",
    "Caraïbes",
    "Gilles EUGENE",
    "EUGENE",
    "GWI"
  ];

  /* =========================================================================
     I18N : FR / EN / ES
     IMPORTANT :
     - FR DOIT exister sinon le script page peut choisir “en” par défaut
     - Le bouton doré (pos) lit petals.pos => traduit ici.
     ========================================================================= */

  const I18N = {
    fr: {
      ui: {
        btn_audio: "Présentation audio",
        btn_text:  "Présentation texte",
        btn_home:  "Accueil",
        modal_audio:"Audio",
        modal_close:"Fermer",
        modal_stop: "Stop"
      },
      petals: {
        who: "Qui est Goodÿ ?",
        approach: "Sa démarche",
        journey: "Son parcours",
        writings: "Ses écrits",
        works: "Les<br>œuvres",
        pos: "Le Posœnnoïsme",
        aria_journey: "Son parcours",
        aria_writings: "Ses écrits",
        aria_works: "Les œuvres",
        aria_pos: "Le Posœnnoïsme"
      },
      intro:
`Il existe des œuvres que l’on “aime”, et d’autres que l’on choisit comme on choisit un cap.

✔️ Une œuvre de Goodÿ (Gilles EUGENE), artiste-auteur guadeloupéen, appartient à cette seconde famille :
👉 elle parle au temps long, à celles et ceux qui reconnaissent la valeur des décisions mûries, des trajectoires assumées, et de ce qui agit en profondeur, parfois hors du spectaculaire.

✔️ Acquérir une œuvre de Goodÿ, c’est dépasser l’impulsion décorative.
👉 C’est entrer dans une démarche, dans un travail qui se déploie depuis le début des années 2000, à la fois :
 - plastique,
 - poétique,
 - philosophique.
👉 Un travail qui s’inscrit dans un corpus structuré : Posœnnoïsme, fondé par l’artiste.

✔️ Faire l’acquisition d’une œuvre de Goodÿ, c’est aussi accueillir une manière de penser simultanément :
 - la matière,
 - la mémoire,
 - le visible et l’invisible,
 - le matériel et l’immatériel,
 - les cultures et les histoires.
👉 Une œuvre qui continue de travailler longtemps après l’accrochage.`,
      modal: {
        who: {
          title: "Qui est Goodÿ ?",
          html:
`<p>Né en 1975 en Guadeloupe, Goodÿ a exposé en Guadeloupe, en Martinique, en France, en Floride et en Europe. Ses œuvres figurent dans plusieurs collections privées et publiques.</p>

<p>Sa pratique a été distinguée au concours PIPA (Mondial Art Académia) et a reçu une Médaille d’Or en 2024 (Colombian Art Gallery), une Médaille de Bronze en 2020, ainsi que plusieurs mentions honorables. Il est artiste certifié i-CAC.</p>

<p>Artiste pluridisciplinaire, il traverse expositions, conférences, performances, publications et recherches comme autant de champs d’expression. De ces croisements émerge une approche transversale et additive, aux intersections mobiles de l’abstraction, des spiritualités et de la gnose : le Posœnnoïsme, progressivement formalisé au fil du temps.</p>

<p>« La Ligne », écrit Goodÿ, « soutient des dynamiques gestuelles, strates, superpositions, transparences et symboles fragmentés — revisités ou transmutés : l’invisible et le visible ». Ligne de force, de passage, de fracture ou d’union, elle devient une métaphore active : elle relie êtres, temps, espaces, imaginaires et perceptions.</p>

<p>À travers le Posœnnoïsme, Goodÿ explore les marges du visible, les tensions entre intuition et construction, silence et éclat. La peinture devient un territoire de passage, une métamorphose vivante et permanente invitant à la contemplation intérieure et à l’exploration sensible de mémoires encodées dans le geste.</p>

<p>Parallèlement à sa pratique, Goodÿ s’engage dans la défense des droits des artistes-auteurs et de la diversité culturelle. Il est Secrétaire Général du CAAP, personnalité qualifiée de l’USOPAVE, et membre de l’ADAGP, de RITAA Guadeloupe, de la Fondation Taylor, de Mondial Art Academia, d’Italia In Arte Nel Mondo, de l’IAA/AIAP (UNESCO), ainsi que membre des conseils d’administration de MAPRAA, du CFC et de Documents d’Artiste Caraïbes.</p>

<p>Il intervient régulièrement dans des contextes institutionnels, pédagogiques et culturels.</p>

<div class="goody-source">Le Posœnnoïste, Juin 2025</div>`
        },
        approach: {
          title: "Sa démarche",
          html:
`<p>Derrière ce nom d’artiste, une articulation simple et dense. « Good » signale d’abord une justesse intime, un accord initial avec ce qui, pour lui, fait sens et direction. Le « ÿ » (y tréma) introduit une tension du regard : une vigilance permanente à l’égard des mutations du monde, attentive à ses fractures comme à ses promesses silencieuses. Ce signe graphique agit comme un axe optique : il indique une vision tenue éveillée, jamais close, offerte au partage. Il pointe aussi plus profond : la plasticité de l’invisible — ces structures impalpables (pensée, mémoire, cosmos intérieur) capables de se reconfigurer, de prendre forme, de changer de forme et de revenir comme puissance d’émergence.</p>

<p>Depuis plus de vingt ans, l’œuvre se déploie comme une démarche transformatrice, vibratoire, symbolique et théorique, où la création n’apparaît pas comme simple objet mais comme espace d’activation intérieure et de passage. Chaque pièce s’adosse à une architecture conceptuelle rigoureuse, le Posœnnoïsme, au sein de laquelle l’art devient opérateur de traversée : traversée du sensible, des mémoires, des systèmes de pensée et des régimes du temps.</p>

<p>L’ancrage est caribéen, guadeloupéen, pluriel par nature. Non une identité fixe, mais un champ de tensions, de strates et d’héritages entrelacés. Les mémoires postcoloniales s’y approchent sans réduction : comme forces complexes, actives, toujours en devenir. Chaque œuvre fonctionne ainsi comme un espace de médiation entre mémoires individuelles et mémoires collectives, ouvrant la création à un dialogue qui excède les géographies et les appartenances, vers une projection universelle.</p>

<p>« Tout est dans tout », disait Anaxagore il y a près de vingt-cinq siècles. Cette intuition irrigue le travail en profondeur. Par l’accumulation minutieuse de couches picturales fines — sans collage ni surcharge matérielle — se tracent des champs fréquentiels mobiles, où la couleur devient temps, et la ligne, respiration. Transparence et opacité dialoguent ; fixité et mutation se répondent : l’œuvre ne représente pas le temps, elle en propose une expérience.</p>

<p>Enracinée dans les mémoires caribéennes et les héritages postcoloniaux, la recherche conjugue rigueur et intuition. Elle s’alimente à de multiples systèmes symboliques, philosophiques et religieux — kabbale, christianisme, mandéisme, mythologies anciennes — non pour les citer, mais pour en activer les résonances. De ces croisements émergent des modulations de fréquences, des cycles spatio-temporels, des structures immatérielles, pensées et articulées au sein du Posœnnoïsme, soutenues par une matrice fondamentale : Katûvýs.</p>

<p>Ainsi l’œuvre se tient au carrefour du visible et de l’invisible, du concept et du sensible, du calcul et du souffle. Elle rappelle — sans se faire morale — que toute trajectoire relève d’un choix : choix d’orientation, de posture, de fidélité à une vibration intérieure.</p>

<div class="goody-source">Le Posœnnoïste, Juin 2025</div>`
        }
      }
    },

    en: {
      ui: {
        btn_audio: "Audio presentation",
        btn_text:  "Text presentation",
        btn_home:  "Home",
        modal_audio:"Audio",
        modal_close:"Close",
        modal_stop: "Stop"
      },
      petals: {
        who: "Who is Goodÿ?",
        approach: "His approach",
        journey: "His journey",
        writings: "His writings",
        works: "The<br>works",
        pos: "Posœnnoism",
        aria_journey: "His journey",
        aria_writings: "His writings",
        aria_works: "The works",
        aria_pos: "Posœnnoism"
      },
      intro:
`There are works we “like”, and others we choose the way we choose a heading.

✔️ A work by Goodÿ (Gilles EUGENE), a Guadeloupean artist-author, belongs to that second family:
👉 it speaks to the long term—to those who recognize the value of matured decisions, assumed trajectories, and what acts in depth, sometimes beyond the spectacular.

✔️ Acquiring a work by Goodÿ means moving beyond a decorative impulse.
👉 It means entering a practice—a body of work unfolding since the early 2000s, at once:
 - visual,
 - poetic,
 - philosophical.
👉 A work anchored in a structured corpus: Posœnnoism, founded by the artist.

✔️ To acquire a work by Goodÿ is also to welcome a way of thinking simultaneously:
 - matter,
 - memory,
 - the visible and the invisible,
 - the material and the immaterial,
 - cultures and histories.
👉 A work that continues to work within you long after it is hung.`,
      modal: {
        who: {
          title: "Who is Goodÿ?",
          html:
`<p>Born in 1975 in Guadeloupe, Goodÿ has exhibited in Guadeloupe, Martinique, France, Florida, and Europe. His works belong to several private and public collections.</p>

<p>His practice has been recognized at the PIPA competition (Mondial Art Académia) and received a Gold Medal in 2024 (Colombian Art Gallery), a Bronze Medal in 2020, as well as multiple honorable mentions. He is an i-CAC certified artist.</p>

<p>A multidisciplinary artist, he moves through exhibitions, lectures, performances, publications, and research as so many fields of expression. From these crossings emerges a transverse and additive approach, at the shifting intersections of abstraction, spirituality, and gnosis: Posœnnoism, progressively formalized over time.</p>

<p>“The Line,” writes Goodÿ, “supports gestural dynamics, strata, superimpositions, transparencies, and fragmented symbols—revisited or transmuted: the invisible and the visible.” As force-line, passage, fracture, or union, it becomes an active metaphor: it connects beings, times, spaces, imaginaries, and perceptions.</p>

<p>Through Posœnnoism, Goodÿ explores the margins of the visible, the tensions between intuition and construction, silence and flare. Painting becomes a passage-ground, a living and permanent metamorphosis inviting inner contemplation and a sensitive exploration of memories encoded in gesture.</p>

<p>Alongside his artistic practice, Goodÿ is deeply engaged in the defense of artists-authors’ rights and cultural diversity. He is Secretary General of the CAAP, a qualified personality of the USOPAVE, and a member of ADAGP, RITAA Guadeloupe, Fondation Taylor, Mondial Art Academia, Italia In Arte Nel Mondo, the IAA/AIAP (UNESCO), as well as a board member of MAPRAA, CFC, and Documents d’Artiste Caraïbes.</p>

<p>He regularly contributes in institutional, pedagogical, and cultural contexts.</p>

<div class="goody-source">Le Posœnnoïste, June 2025</div>`
        },
        approach: {
          title: "His approach",
          html:
`<p>Behind this artist’s name lies a simple, dense articulation. “Good” first signals an intimate rightness—an initial accord with what, for him, gives meaning and direction. The “ÿ” (y with diaeresis) introduces a tension of gaze: a constant vigilance toward the world’s transformations, attentive to its fractures as well as its silent promises. This graphic sign acts as an optical axis: it indicates a vision kept awake, never closed, offered for sharing. It also points to something deeper: the plasticity of the invisible—those impalpable structures (thought, memory, inner cosmos) able to reconfigure, to take form, to change form, and to return as a power of emergence.</p>

<p>For more than twenty years, the work has unfolded as a transformative, vibratory, symbolic, and theoretical approach, where creation appears not as a mere object but as a space of inner activation and passage. Each piece belongs to a rigorous conceptual architecture, Posœnnoism, within which art becomes an operator of traversal: traversal of the sensible, of memory, of systems of thought, and of regimes of time.</p>

<p>The anchoring is Caribbean, Guadeloupean, plural by nature. Not a fixed identity, but a field of tensions, strata, and interwoven inheritances. Postcolonial memories are approached without reduction: as complex forces, active, always becoming. Each work functions as a mediation-space between individual and collective memories, opening creation toward a dialogue that exceeds geographies and belongings, reaching a universal scope.</p>

<p>“Everything is in everything,” said Anaxagoras nearly twenty-five centuries ago. This intuition irrigates the work in depth. Through the meticulous accumulation of thin pictorial layers—without collage or material overload—mobile frequency-fields are traced, where color becomes time, and line, breath. Transparency and opacity converse; fixity and mutation answer each other: the work does not represent time, it offers an experience of it.</p>

<p>Rooted in Caribbean memories and postcolonial inheritances, the research joins rigor and intuition. It draws from multiple symbolic, philosophical, and religious systems—Kabbalah, Christianity, Mandaeism, ancient mythologies—not to quote them, but to activate their resonances. From these crossings emerge frequency-modulations, spatio-temporal cycles, immaterial structures, thought and articulated within Posœnnoism, and sustained by a fundamental matrix: Katûvýs.</p>

<p>Thus the work stands at the crossroads of visible and invisible, concept and sensible, calculation and breath. It recalls—without turning into moral—that every trajectory is a matter of choice: a choice of direction, of stance, of fidelity to an inner vibration.</p>

<div class="goody-source">Le Posœnnoïste, June 2025</div>`
        }
      }
    },

    es: {
      ui: {
        btn_audio: "Presentación audio",
        btn_text:  "Presentación texto",
        btn_home:  "Inicio",
        modal_audio:"Audio",
        modal_close:"Cerrar",
        modal_stop: "Detener"
      },
      petals: {
        who: "¿Quién es Goodÿ?",
        approach: "Su enfoque",
        journey: "Su recorrido",
        writings: "Sus escritos",
        works: "Las<br>obras",
        pos: "Posœnnoísmo",
        aria_journey: "Su recorrido",
        aria_writings: "Sus escritos",
        aria_works: "Las obras",
        aria_pos: "Posœnnoísmo"
      },
      intro:
`Hay obras que “nos gustan”, y otras que elegimos como se elige un rumbo.

✔️ Una obra de Goodÿ (Gilles EUGENE), artista-autor guadalupeño, pertenece a esa segunda familia:
👉 habla al tiempo largo, a quienes reconocen el valor de las decisiones maduradas, de las trayectorias asumidas y de lo que actúa en profundidad, a veces fuera de lo espectacular.

✔️ Adquirir una obra de Goodÿ es ir más allá del impulso decorativo.
👉 Es entrar en una práctica, en un trabajo que se despliega desde comienzos de los años 2000, a la vez:
 - plástico,
 - poético,
 - filosófico.
👉 Un trabajo inscrito en un corpus estructurado: Posœnnoísmo, fundado por el artista.

✔️ Adquirir una obra de Goodÿ es también acoger una manera de pensar simultáneamente:
 - la materia,
 - la memoria,
 - lo visible y lo invisible,
 - lo material y lo inmaterial,
 - las culturas y las historias.
👉 Una obra que sigue trabajando mucho después de colgarse.`,
      modal: {
        who: {
          title: "¿Quién es Goodÿ?",
          html:
`<p>Nacido en 1975 en Guadalupe, Goodÿ ha expuesto en Guadalupe, Martinica, Francia, Florida y Europa. Sus obras figuran en varias colecciones privadas y públicas.</p>

<p>Su trabajo ha sido reconocido en el concurso PIPA de la Mondial Art Académia y recibió la Medalla de Oro en 2024 (Colombian Art Gallery), la Medalla de Bronce en 2020, así como varias menciones honoríficas. Es artista certificado i-CAC.</p>

<p>Artista multidisciplinar, atraviesa exposiciones, conferencias, performances, publicaciones e investigaciones como tantos campos de expresión. De estos cruces nace un enfoque transversal y aditivo, en las intersecciones móviles de la abstracción, las espiritualidades y la gnosis: Posœnnoísmo, que formaliza progresivamente con el tiempo.</p>

<p>“La Línea”, escribe Goodÿ, “sostiene dinámicas gestuales, estratos, superposiciones, transparencias y símbolos fragmentados—revisitados o transmutados: lo invisible y lo visible”. Línea de fuerza, de paso, de fractura o de unión, se vuelve una metáfora activa: enlaza seres, tiempos, espacios, imaginarios y percepciones.</p>

<p>A través de Posœnnoísmo, Goodÿ explora los márgenes de lo visible, las tensiones entre intuición y construcción, entre silencio y destello. La pintura se convierte en un territorio de paso, una metamorfosis viva y permanente que invita a la contemplación interior y a la exploración sensible de memorias codificadas en el gesto.</p>

<p>Paralelamente a su práctica artística, Goodÿ está profundamente comprometido con la defensa de los derechos de los artistas-autores y de la diversidad cultural. Es secretario general del CAAP, personalidad cualificada de la USOPAVE, y miembro de ADAGP, RITAA Guadeloupe, Fondation Taylor, Mondial Art Academia, Italia In Arte Nel Mondo, IAA/AIAP (UNESCO), así como miembro de los consejos de administración de MAPRAA, CFC y Documents d’Artiste Caraïbes.</p>

<p>Interviene regularmente en contextos institucionales, pedagógicos y culturales.</p>

<div class="goody-source">Le Posœnnoïste, Junio 2025</div>`
        },
        approach: {
          title: "Su enfoque",
          html:
`<p>Detrás de este nombre de artista hay una articulación simple y densa. “Good” designa ante todo una justeza íntima, un acuerdo inicial con lo que para él constituye sentido y orientación. El “ÿ” (y con diéresis) introduce una tensión de la mirada: una vigilancia permanente hacia las mutaciones del mundo, atenta a sus líneas de fractura y a sus promesas silenciosas. Este signo gráfico actúa como un eje óptico: indica una visión en vela, nunca cerrada, ofrecida al compartir. Señala también algo más profundo: la plasticidad de lo invisible, esa capacidad de las estructuras impalpables—pensamiento, memoria, cosmos interior—para reconfigurarse, tomar forma, cambiar de forma y volver a ser potencia de emergencia.</p>

<p>Desde hace más de veinte años, la obra se despliega como un enfoque transformador, vibratorio, simbólico y teórico, donde la creación no aparece como simple objeto, sino como espacio de activación interior y de paso. Cada pieza se inscribe en una arquitectura conceptual rigurosa, Posœnnoísmo, en cuyo seno el arte se vuelve operador de travesía: travesía de lo sensible, de las memorias, de los sistemas de pensamiento y de los regímenes del tiempo.</p>

<p>El anclaje es caribeño, guadalupeño, plural por esencia. No se trata de una identidad fija, sino de un campo de tensiones, de estratos, de herencias entrelazadas. Las memorias poscoloniales se abordan sin reducción: como fuerzas complejas, activas, siempre en devenir. De este modo, cada obra actúa como un espacio de mediación entre memorias individuales y memorias colectivas, abriendo la creación a un diálogo que excede geografías y pertenencias, hacia una proyección universal.</p>

<p>“Todo está en todo”, afirmaba Anaxágoras hace casi veinticinco siglos. Esta intuición irriga el trabajo en profundidad. Mediante la acumulación minuciosa de capas pictóricas finas—sin collage ni sobrecarga material—se trazan campos frecuenciales móviles, donde el color deviene tiempo y la línea, respiración. Transparencia y opacidad dialogan; fijeza y mutación se responden: la obra no representa el tiempo, ofrece una experiencia del tiempo.</p>

<p>Esta investigación, enraizada en las memorias caribeñas y en los legados poscoloniales, conjuga rigor e intuición. Se nutre de múltiples sistemas simbólicos, filosóficos y religiosos—cábala, cristianismo, mandeísmo, mitologías antiguas—no para citarlos, sino para activar sus resonancias. De estos cruces emergen modulaciones de frecuencias, ciclos espacio-temporales, estructuras inmateriales, pensadas y articuladas en Posœnnoísmo, sostenidas por una matriz fundamental: Katûvýs.</p>

<p>Así, la obra se sitúa en la encrucijada de lo visible y lo invisible, del concepto y de lo sensible, del cálculo y del aliento. Recuerda—sin enunciarlo como moral—que toda trayectoria es asunto de elección: elección de orientación, de postura, de fidelidad a una vibración interior.</p>

<div class="goody-source">Le Posœnnoïste, Junio 2025</div>`
        }
      }
    }
  };

  // --- Publie dans le namespace attendu ---
  // Optimisation: on ne fait le freeze qu’une fois, sur les objets finaux
  NS.I18N = freezeDeep(I18N);
  NS.LEXICON = freezeDeep(LEXICON);

  // --- Expose la “méthode 2” au script page (sans rien casser) ---
  //   const uiKey  = GOODY_SPLASH_I18N.resolveUiKey(document.documentElement.lang);
  //   const lexKey = GOODY_SPLASH_I18N.resolveLexiconKey(navigator.language);
  //   const posLabel = GOODY_SPLASH_I18N.I18N[lexKey].petals.pos;
  NS.normalizeLangTag = normalizeLangTag;

  NS.resolveUiKey = function(langTag){
    return resolveUiKey(langTag, NS.I18N);
  };

  NS.resolveLexiconKey = function(langTag){
    return resolveLexiconKey(langTag, NS.I18N);
  };

  // (optionnel) rappel de la règle en données
  NS.LANG_POLICY = freezeDeep({
    ui: "base-if-available-else-fr",
    lexicon: {
      "es-*": "es",
      "pt-*": "es",
      "en-*": "en",
      "default": "base-if-available-else-fr"
    }
  });

  // console.log("GOODY_SPLASH_I18N loaded", Object.keys(NS.I18N), NS.LEXICON.length, NS.LANG_POLICY);
})();